import { type MutationYatsHideArgs, type MutationYatsShowArgs, type QueryYatsArgs } from '@pkg/graphql/codegen/graphql';
import { yatsHide, yatsShow } from '@pkg/graphql/mutations';
import { getUserYats } from '@pkg/graphql/queries';

import { type BaseParams, graphqlMutation, graphqlQuery } from '@app/client';

export const callHideYats = (params: { variables: MutationYatsHideArgs }) =>
    graphqlMutation({
        ...params,
        query: yatsHide,
    });
export const callShowYats = (params: { variables: MutationYatsShowArgs }) =>
    graphqlMutation({
        ...params,
        query: yatsShow,
    });

export const callGetUserYats = async (params: BaseParams & { variables: QueryYatsArgs }) =>
    graphqlQuery({
        ...params,
        query: getUserYats,
    });
